<template>
	<div class="page_content">
		<div class="page_edit_content">
			<Form ref="form" @handleSubmit="handleSubmit" :form_data="form_data">
				<template #rule_info>
					<div class='level_box'>
						<p class="info_p" v-for="(item,index) in info_list" :key='index'>

							<a-input class="info_input_first" disabled v-model:value="item.grade_name" />

							<a-input @input="changNumber()" class="info_input"
								v-if='index!=0&&index!=info_list.length-1' v-model:value="item.field2"
								placeholder="请输入单位" />

							<span class="info_dese" v-if='index==0||index==info_list.length-1'> 年销量（件）{{item.field1}}
							</span>

							<span class="info_dese" v-else>{{item.field1}} 年销量（件）{{item.field3}} </span>


							<a-input @input="changNumber()" class="info_input"
								:disabled='index==info_list.length-1&&info_list.length>1?true:false'
								v-if='index==0||index==info_list.length-1' v-model:value="item.field2"
								placeholder="请输入单位" />


							<a-input disabled class="info_input" v-else v-model:value="item.field4"
								placeholder="请输入单位" />
							<a-icon type="delete" @click='del_list(index)' v-if='index==info_list.length-2' />

						</p>
						<a-button @click='add' type="primary">
							新增
						</a-button>

					</div>
				</template>

			</Form>
		</div>

		<a-modal title="等级规则配置上限提醒" :visible="visible" @ok="add_grade_visible=true;visible=false"
			@cancel="visible=false">
			<p>当前等级类别规则配置已达最大上限，
				可先新增“<a href="#">等级类别</a>”</p>
		</a-modal>


		<a-modal title="配置等级类别" @onCancel='add_grade_visible=false;' v-model:visible="add_grade_visible"
			@ok="add_grade_ok" width="600px" class="modal">
			<p style="margin-bottom: 10px;">
				“等级规则”配置上限等于以下“等级类别”数量，请先新增等级类别
			</p>

			<div class="item">
				<a-button @click='rule_info.push({"id":"","name":"","unit":1})' type="primary">
					新增
				</a-button>
			</div>
			<div class="item">
				<p class="unit_p" v-for="(item,index) in rule_info">
					<span class="level">第{{toChineseNum(index+1)}}级别</span>
					<a-input v-model:value="item.name" placeholder="请输入等级类别名称" />
					<a-icon class="level" type="delete" @click='del_grade_list(item,index)' />
				</p>
			</div>
		</a-modal>

	</div>
</template>

<script>
	import EditPop from "@/components/EditPop";
	import Form from "@/components/Form";
	import {
		saveLevelRule,
		getMarketAndType,
		getLevelRuleDetail,
		saveCustomerRuleGrade
	} from "@/api/market_type";
	import {
		Modal,
		message
	} from 'ant-design-vue';
	// import { try } from 'q';

	export default {
		components: {
			Form,
			EditPop,
		},
		data() {
			return {
				index: -1, //编辑时使用
				visible: false,
				ModalText: '',
				info_list: [],
				rule_info: [],
				add_grade_visible: false,
				form_data: {
					title: "新增类型登记",
					show_submit_btn: true,
					show_close_btn: true,
					close_reset_btn: true,
					list: [{
							type: "text",
							name: "id",
							hidden: true,
							options: {
								initialValue: ""
							}
						},
						{
							type: "text",
							name: "name",
							title: "标签名字",
							options: {
								initialValue: ""
							}
						},
						{
							type: "select",
							name: "market_id",
							title: "市场类型",
							options: {
								rules: [{
									required: true,
									message: "请选择市场类型"
								}],
								initialValue: null
							},
							list: []
						},
						{
							type: "select",
							name: "type_id",
							title: "客户类别",
							options: {
								rules: [{
									required: true,
									message: "请选择客户类别"
								}],
								initialValue: null
							},
							list: []
						},
						{
							type: "slot",
							name: "rule_info",
							title: "等级规则",
							options: {
								initialValue: ""
							}
						},


					]
				},


			};
		},
		async created() {
			let info_id = this.$router.currentRoute.query.info_id;
			if (info_id) {
				this.get_list();
			}
			getMarketAndType().then(info => {
				this.form_data.list[2].list = info.data.market_type.map(it => {
					return {
						value: it.label,
						key: it.value
					}
				})
				this.rule_info = info.data.grade.map(it => {
					it.name = it.label
					it.id = it.value
					return it
				})
				this.form_data.list[3].list = info.data.rule_type.map(it => {
					return {
						value: it.label,
						key: it.value
					}
				})
			})


		},
		methods: {

			changNumber() {

				this.info_list.forEach((it, index) => {
					if (index > 0) {
						if (this.info_list.length == 2 && (index == this.info_list.length - 1)) {
							it.field2 = this.info_list[0].field2
						} else {
							if (index == this.info_list.length - 1) {
								it.field2 = this.info_list[this.info_list.length - 2].field2
							} else {
								it.field4 = this.info_list[index - 1].field2
							}
						}
					}

				})
			},
			del_grade_list(item, index) {
				let arr = this.info_list.map(it => {
					return it.grade_id
				})
				if (arr.indexOf(item.id) > -1) {
					let that = this
					Modal.confirm({
						title: () => '等级类别删除提示',
						content: () => '是否确认删除当前等级类别，删除后，该类别关联配置项将会清除，请谨慎操作？',
						okText: '确认',
						cancelText: '取消',
						onOk() {
							that.info_list.splice(arr.indexOf(item.id), 1)
							that.rule_info.splice(index, 1)
							that.info_list.forEach((it, index) => {
								if (that.info_list.length == 2 && (index == that.info_list.length - 1)) {
									it.field1 = "<"
									it.field3 = ""
								} else if (index == 0) {
									it.field1 = "≥"
									it.field3 = ""
								} else {
									if ((index == that.info_list.length - 1)) {
										it.field1 = "<"
										it.field3 = ""
									} else {
										it.field1 = "≤"
										it.field3 = "<"
									}
								}
							})
						},
						onCancel() {},
					});
				} else {
					this.rule_info.splice(index, 1)
				}
			},

			toChineseNum(num) {
				const map = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
				if (num >= 1 && num <= 10) return map[num];
				// 如需支持更大数字，可自行扩展
				return num; // fallback
			},
			add_grade_ok() {
				saveCustomerRuleGrade({
					data: {
						grade: this.rule_info.map(it => {
							return {
								id: it.id,
								name: it.name,
								"unit": 1
							}
						})
					}
				}).then(res => {
					message.success('保存成功')
					this.add_grade_visible = false
					getMarketAndType().then(info => {
						this.rule_info = info.data.grade
					})

				})
			},
			del_list(index) {

				this.info_list.splice(index, 1)
				this.info_list.forEach((it, index) => {
					it.grade_id = this.rule_info[index].value
					it.grade_name = this.rule_info[index].label


					if (this.info_list.length == 2 && (index == this.info_list.length - 1)) {
						it.field1 = "<"
						it.field3 = ""
					} else if (index == 0) {
						it.field1 = "≥"
						it.field3 = ""
					} else {
						if ((index == this.info_list.length - 1)) {
							it.field1 = "<"
							it.field3 = ""
						} else {
							it.field1 = "≤"
							it.field3 = "<"
						}

					}
				})

				this.changNumber()


			},
			add() {
				if (this.rule_info.length == 0 || this.rule_info.length == this.info_list.length) {
					this.visible = true
				} else {
					let obj = {
						"grade_id": this.rule_info[this.info_list.length].value, //级别id
						"grade_name": this.rule_info[this.info_list.length].label, //级别名称
						"field1": '', //符号1
						"field2": 0, //数量1
						"field3": '', //符号1, //符号2
						"field4": this.info_list[this.info_list.length - 1] ? this.info_list[this.info_list
							.length - 1].field2 : 0
					}

					this.info_list.push(obj)

					this.info_list.forEach((it, index) => {
						if (this.info_list.length == 2 && (index == this.info_list.length - 1)) {
							it.field1 = "<"
							it.field3 = ""
						} else if (index == 0) {
							it.field1 = "≥"
							it.field3 = ""
						} else {
							if ((index == this.info_list.length - 1)) {
								it.field1 = "<"
								it.field3 = ""
							} else {
								it.field1 = "≤"
								it.field3 = "<"
							}

						}
					})

					this.changNumber()
				}
			},
			async get_list(e) {
				let info_id = this.$route.query.info_id;
				getLevelRuleDetail({
					data: {
						id: info_id
					}
				}).then(res => {
					this.info_list = res.data.data.rule_info
					this.form_data.list[1].options.initialValue = res.data.data.name
					this.form_data.list[0].options.initialValue = res.data.data.id
					this.form_data.list[2].options.initialValue = res.data.data.market_id
					this.form_data.list[3].options.initialValue = res.data.data.type_id
				})
			},

			handleSubmit(e) {
				let value = e.values
				this.info_list.forEach((it, index) => {
					if (index == this.info_list.length - 1) {
						it.field1 = "<"
					}
				})
				let obj = {
					...value,
					rule_info: this.info_list
				}
				try {
					saveLevelRule({
						data: obj,
						info: true,
					}).then(res => {
						this.$router.go(-1)
					}).catch(error => {

					})

				} catch {

				}
			},

		}
	};
</script>
<style lang="less">
	.unit_p {
		display: flex;
		align-items: center;
		margin-top: 12px;

		.level {
			width: 150px;
		}

		.delete_icon {
			color: red;
		}

	}

	.info_p {
		display: flex;
		align-items: center;

		.info_input {
			width: 150px;
			margin-right: 12px;
			margin-right: 12px;
		}

		.info_input_first {
			width: 100px;
			margin-right: 12px;
			margin-right: 12px;
		}

		.info_dese {
			text-align: center;
			width: 150px;
		}

		.info_dese_box {
			display: flex;
			align-items: center;
		}
	}

	.level_box {
		width: 650px;
		height: auto;
		padding: 12px 24px;
		background: #f7f7f7;
		border: 1px solid #eee;
		border-radius: 4px;
	}
</style>